import { render } from "./Technology-consulting-en.vue?vue&type=template&id=1d80af88&scoped=true"
import script from "./Technology-consulting-en.vue?vue&type=script&lang=js"
export * from "./Technology-consulting-en.vue?vue&type=script&lang=js"

import "./Technology-consulting-en.vue?vue&type=style&index=0&id=1d80af88&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d80af88"]])

export default __exports__